import en from '@/i18n/locales/en.json';
import { locale as dxLocale } from 'devextreme/localization';
import { createI18n } from 'vue-i18n';

/** The shape of every locale's messages; en.json is the source of truth. */
export type MessageSchema = typeof en;

declare module 'vue-i18n' {
    // Types `$t` and `t` against en.json (autocompletion; unknown keys are caught by i18n.spec.ts).
    // oxlint-disable-next-line typescript/no-empty-object-type
    export interface DefineLocaleMessage extends MessageSchema {}
}

/**
 * The single locale is fixed at startup. A second one means a `<culture>.json` next to en.json, the
 * matching `devextreme/localization/messages/<culture>.json` (loadMessages), `<html lang>` (fixed to `en` in
 * index.html) set to it, and a page reload on change: DevExtreme only applies a new locale to widgets created after it.
 */
export const i18n = createI18n<[MessageSchema], 'en', false>({
    legacy: false,
    locale: 'en',
    fallbackLocale: 'en',
    messages: { en }
});

dxLocale(i18n.global.locale.value);

/** `t` for code outside a component's template: stores, helpers, constants and script setup. */
export const t = i18n.global.t;
